import { Login } from '@/helper/user';
import HdlToast from '@/utils/toast';
import { TOKEN_KEY } from '@/helper/common/constant';
export default function errorHandle(error: any) {
  const { response, message } = error;
  if (response) {
    const { status } = error.response;
    switch (status) {
      case 401: //未授权,请重新登录
        sessionStorage.removeItem(TOKEN_KEY);
        Login();
        break;
      // case 504: //网关超时
      // case 502: //网关超时
      // case 501: //网关超时
      //   window.location.hash = '/error/netWorkError'; //网络超时
      //   break;
      case 400:
        HdlToast.info('错误请求');
        break;
      case 403:
        HdlToast.info('拒绝访问');
        break;
      case 404:
        HdlToast.info('请求错误,未找到该资源');
        break;
      case 405:
        HdlToast.info('请求方法未允许');
        break;
      case 408:
        HdlToast.info('请求超时');
        break;
      case 500:
        HdlToast.info('网络出错了(500)');
        break;
      case 503:
        HdlToast.info('服务不可用');
        break;
      case 505:
        HdlToast.info('http版本不支持该请求');
        break;
      default:
        HdlToast.info(message || `连接错误${status}`);
    }
  }
}
